<template>
  <div id="parent">
    <div class="header">
      <div><span class="label">User ID:</span>{{ userId }}</div>
      <div><span class="label">Manager ID:</span>{{ managerId }}</div>
      <div><span class="label">Error count:</span><span id="error-count" v-bind:class="{ active: errors.length > 0 }">{{ errors.length }}</span></div>
      <div id="action-status"><span class="label">Action status:</span><span v-bind:class="{ active: actionStatus !== 'none' }">{{ actionStatus }}</span></div>
      <div id="actions-container">
        <div>
          <router-link to="reports" class="action-btn">Reports</router-link>
          <button id="ifc-clear-errors" class="action-btn" @click="removeErrors">Clear Errors</button>
          <button id="ifc-close-report-backend" class="action-btn" @click="closeReport" :title="closeReportDesc">Close on Backend</button>
          <button v-if="!isOpen" id="show-iframe" class="action-btn" @click="open">Show iframe</button>
        </div>
        <div>
          <button id="copy-one-row" class="action-btn" @click="copyToClipboard(1, 'copy-one-row')">Copy One Row</button>
          <button id="copy-multiple-rows" class="action-btn" @click="copyToClipboard(200, 'copy-multiple-rows')">Copy 200 Rows</button>
          <button id="copy-too-many-rows" class="action-btn" @click="copyToClipboard(201, 'copy-too-many-rows')">Copy 201 Rows</button>
        </div>
      </div>
    </div>
    <div class="errors">
      <div v-for="(error, index) in errors" :key="`error-${index}`" class="error">
        {{error}}
      </div>
    </div>
    <div v-if="isOpen">
      <iframe id="grid-frame" :src="src"></iframe>
    </div>
  </div>
</template>

<script>
// This file is only for development and testing
// It is not intended to be used in production
import Vue from 'vue'
import { Reports } from '@/api'
import { extractIsInEditMode } from '@/data-extraction/reports'
import Clipboard from '@/clipboard/clipboard'

const ActionMessages = {
  none: 'none',
  fetching: 'Fetching the report',
  closing: 'Closing the report on the backend only',
  closed: 'The report is closed on the backend',
  removedErrors: 'Removed all errors'
}

export default {
  props: {
    userId: {
      type: Number,
      required: true
    },
    managerId: {
      type: String,
      required: true
    }
  },
  computed: {
    src () {
      return this.baseUrl + `?managerId=${this.managerId}`
    }
  },
  data () {
    return {
      baseUrl: '/hubble/2/grid',
      isOpen: true,
      channel: null,
      errors: [],
      closeReportDesc: 'This will send an API request to close report, the child page will not be informed of the change of state.',
      actionStatus: ActionMessages.none
    }
  },
  methods: {
    setupChannel () {
      const vm = this
      window.onmessage = function (event) {
        if (event.data[0] !== '{') { // probably not an error message from the grid, could be from webpack
          return
        }

        const meta = JSON.parse(event.data)
        if (meta.method === 'close') {
          vm.isOpen = false
        }
        if (meta.method === 'error') {
          vm.errors.push(meta.params[0].message)
        }
      }
    },
    open () {
      this.isOpen = true
      // we do this on the next vue tick, so that the iframe can be found by document.getElementById
      Vue.nextTick(this.setupChannel)
    },
    copyToClipboard (rows, id) {
      var clipBoardText = ''
      for (var i = 0; i < rows; i++) {
        clipBoardText += '1111\n'
      }
      Clipboard.newClipboard('#' + id, clipBoardText)
    },
    closeReport () {
      this.actionStatus = ActionMessages.fetching
      Reports.getReport(this.userId, this.managerId, 0, 1, true)
        .then(extractIsInEditMode)
        .then(open => {
          if (open) {
            this.actionStatus = ActionMessages.closing
            return Reports.switchModes(this.userId, this.managerId)
          }
        })
        .then(() => {
          this.actionStatus = ActionMessages.closed
          this.resetActionStatus()
        })
        .catch(err => {
          this.actionStatus = 'Unexpected error in parent page: ' + err.message
        })
    },
    removeErrors () {
      this.errors = []
      this.actionStatus = ActionMessages.removedErrors
      this.resetActionStatus()
    },
    resetActionStatus () {
      setTimeout(() => { this.actionStatus = ActionMessages.none }, 4000)
    }
  },
  created () {
    this.setupChannel()
  }
}
</script>

<style scoped>
  iframe {
    border: 0px solid grey;
    width: 100%;
    height: 500px;
    box-shadow: rgba(0,0,0,0.3) 0px 1px 6px 0px;
  }

  #test-grid {
    height: 300
  }

  pre {
    margin: 20px 0;
  }

  #errors.has-errors {
    visibility: visible;
    margin: 10px 0;
  }

  .error {
    background-color: #f9a9b2;
    border: 2px solid #b70e20;
    box-shadow: rgba(0,0,0,0.3) 0px 1px 6px 0px;
    padding: 10px;
    margin: 10px 0;
  }

  .header {
    background-color: #18a7aa;
    box-shadow: rgba(0,0,0,0.3) 0px 1px 6px 0px;
    margin-bottom: 10px;
    padding: 10px;
    /* min-height: 200px; */
  }

  .active {
    color: #e7fbfc;
  }

  .action-btn {
    color: #e7fbfc;
    background: transparent;
    font-weight: normal;
    border: 2px solid #18a7aa;
    border-radius: 6px;
    outline-style: none;
    padding: 16px 10px;
    text-align: center;
    display: inline-block;
    font-size: 14px;
    margin: 4px 4px;
    cursor: pointer;
    text-decoration: none;
    text-transform: uppercase;
  }

  .action-btn:hover {
    color: #fff;
    /* font-weight: bold; */
    background: transparent;
    border: 2px solid #fff;
    text-decoration: none;
 }

 #actions-container {
   display: flex;
   justify-content: space-between;
 }

 .label {
   display: inline-block;
   width: 115px;
 }

</style>
